import React, { Component } from 'react'
import ApplicantsPV from './ApplicantsPV'
import AuthA from '../../store/actions/AuthA'
import Papa from 'papaparse'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import upperCase from 'upper-case'
import moment from 'moment'
import {connect} from 'react-redux'

const _ = {
  sortBy, find
}

const changeCase = {
  upperCase
}

class ApplicantsPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchKey: '',
      fields: ['applicantNumber','type','lastName', 'firstName', 'email', 'paymentSchedule', 'AA', 'UE', 'clear', 'paid', 'actions'],
      activePage: 1,
      itemPerPage: 30,
      selectedIndex: 0,
      column: null,
      direction: null,
      loaded: false,
      results: [],
      modalImportOpen: false,
      schoolYears: [],
      students: [],
      paymentFile: null,
      gradeFile: null,
      gradeFilename: '',
      enrollmentFile: null,
      enrollmentFilename: '',
      gradeLevel: '',
      schoolYearId: ''
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleDataSave = this.handleDataSave.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  getApplicants = () => {
    axios.get(process.env.REACT_APP_URL+`/applicants?filter[where][active]=true&filter[where][schoolYearId]=${this.state.schoolYearId}&filter[order]=created%20DESC`)
    .then(response => {
      this.setState({ data: response.data, loaded: true })
    })
    .catch(err => console.log(err))
  }

  getSchoolYears = () => {
    axios.get(process.env.REACT_APP_URL+'/schoolyears?filter[where][active]=true')
    .then(response => {
      const currentSchoolYear = _.find(response.data, {
        isCurrent: true
      });
      this.setState({
        schoolYears: response.data,
        schoolYearId: currentSchoolYear.schoolYearId
      }, () => {
        setTimeout( async () => {
          this.getApplicants()
        }, 5000)
      });
    });
  }

  getOldStudent = (firstName, lastName) => {
    axios.get(`${process.env.REACT_APP_URL}/students?filter[where][active]=true&filter[where][lastName][like]=${lastName}`)
    .then(response => {
      this.setState({
        students: response.data
      });
    });
  }

  isSearched(searchKey) {
    return function(item) {
      if (item.appNumber) {
        return (
          !searchKey ||
          item.firstName.toLowerCase().includes(searchKey.toLowerCase()) ||
          item.lastName.toLowerCase().includes(searchKey.toLowerCase()) ||
          item.appNumber.includes(searchKey)
        );
      } else {
        return (
          !searchKey ||
          item.firstName.toLowerCase().includes(searchKey.toLowerCase()) ||
          item.lastName.toLowerCase().includes(searchKey.toLowerCase())
        );
      }
    };
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleChangeSchoolYear = (e, { value }) => {
    this.setState({ schoolYearId: value, loaded: false }, () => {
      setTimeout( async () => {
        this.getApplicants()
      }, 2000)
    })
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state
    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })
      return
    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handlePaginationChange(e, {activePage}){
    this.setState({
      activePage: activePage,
    });
  }

  handleFileChange(file) {
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: this.handleDataChange
    });
  }

  handleDataChange(results) {
    // this.handleDataSave(results.data);
    this.setState({results: results.data})
    console.log('Parsing complete:', results);
  }

  handleRowClick(applicant) {
    this.props.history.push(this.props.location.pathname+'/' + applicant.applicantId);
  }

  async handleDataSave() {
    // const content = fileReader.result;
    const data = this.state.results;
    let parsedapplicant = {}, successCount = 0;

    for (let i = 0; i < data.length; i++) {
      parsedapplicant = {
        firstName: data[i]['firstName'],
        middleName: data[i]['middleName'],
        lastName: data[i]['lastName'],
        nickName: data[i]['nickName'],
        gender: data[i]['gender'],
        birthDate: moment(data[i]['birthDate']),
        address: data[i]['address'],
        email: data[i]['email'],
        lrn: data[i]['lrn'],
        applicantNumber: data[i]['applicantNumber'],
        religion: data[i]['religion'],
        placeOfBirth: data[i]['placeOfBirth'],
        mobile1: data[i]['mobile1'],
        mobile2: data[i]['mobile2'],
        contactPerson: data[i]['contactPerson'],
        contactPersonNumber: data[i]['contactPersonNumber'],
        contactPersonAddress: data[i]['contactPersonAddress'],
        guardianName: data[i]['guardianFirstName'] + " " + data[i]['guardianMiddleName'] + " " + data[i]['guardianLastName'] + " " + data[i]['guardianExtensionName'],
        guardianAddress: data[i]['guardianAddress'],
        guardianOccupation: data[i]['guardianOccupation'],
        guardianOfficeAddress: data[i]['guardianOfficeAddress'],
        guardianNumber: data[i]['guardianNumber'],
        beenHospitalized: data[i]['beenHospitalized'],
        hospitalReason: data[i]['hospitalReason'],
        medicalHistory: data[i]['medicalHistory'],
      };
      const url = process.env.REACT_APP_URL+'/applicants';
      try {
        await axios.request({
          method: 'post',
          url: url,
          data: parsedapplicant
        })
        console.log(`Successfully loaded:${i+1}`);
        successCount++;
      } catch(error){

        console.log(error)
        if (error.response) {
          alert(`Line ${i+2}: ${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.setState({modalImportOpen: false}, this.getApplicants())
        break;
      }
    }
    alert(`${successCount} applicant/s successfully uploaded.`)
    this.setState({modalImportOpen: false}, this.getApplicants())
  }

  handleSubmit(data) {
    const url = process.env.REACT_APP_URL+'/applicants';
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {
        alert(`Successfully added an applicant.`)
        this.getApplicants()
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.getApplicants()
      });
  }

  handleUpdate(data,id) {
    const url = process.env.REACT_APP_URL+'/applicants/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {
        alert(`Successfully updated an applicant.`)
        if(this.state.gradeFile !== null) {
          this.handleUploadGradeFile();
        }
        if(this.state.enrollmentFile !== null) {
          this.handleUploadEnrollmentFile();
        }
        this.getApplicants()
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.getApplicants()
      });
  }

  handleDelete(id) {
    const url = process.env.REACT_APP_URL+'/applicants/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: {active: false}
      })
      .then(response => {this.getApplicants()})
      .catch(err => console.log(err));
  }

  handleUploadEnrollmentFileChange = (enrollmentFile, applicant) => {
    const { firstName, lastName, gradeLevel } = applicant;
    const fileType = enrollmentFile.type;
    const fileTypeArray = fileType.split('/');
    const type = fileTypeArray[1];
    const fileName = `${changeCase.upperCase(lastName)}-${changeCase.upperCase(firstName)}-${changeCase.upperCase(gradeLevel)}.${type}`;
    const file = new File([enrollmentFile], fileName, { type: enrollmentFile.type });

    this.setState({enrollmentFile: file, enrollmentFilename: fileName});
  }

  handleUploadGradeFileChange = (gradeFile, applicant) => {
    const { firstName, lastName } = applicant;
    const fileType = gradeFile.type;
    const fileTypeArray = fileType.split('/');
    const type = fileTypeArray[1];
    const fileName = `${changeCase.upperCase(lastName)}-${changeCase.upperCase(firstName)}-REPORTCARD.${type}`;
    const file = new File([gradeFile], fileName, { type: gradeFile.type });

    this.setState({gradeFile: file, gradeFilename: fileName});
  }

  handleUploadEnrollmentFile = () => {
    const url = process.env.REACT_APP_URL+'/assets/upload?module=enrollment';
    let fileData = new FormData();
    fileData.append('filePath', this.state.enrollmentFile);
    axios
      .request({
        method: 'post',
        url: url,
        data: fileData
      })
      .then(response => {
        alert(`Requirements was successfully saved.`);
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
      });
  }

  handleUploadGradeFile = () => {
    const url = process.env.REACT_APP_URL+'/assets/upload?module=reportCard';
    let fileData = new FormData();
    fileData.append('filePath', this.state.gradeFile);
    axios
      .request({
        method: 'post',
        url: url,
        data: fileData
      })
      .then(response => {
        alert(`Report card was successfully saved.`);
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
      });
  }

  handleSaveAsStudent = (data) => {
    const url = process.env.REACT_APP_URL+'/students';
    const studentNumber = data.applicantNumber.substring(4,data.applicantNumber.length);
    // console.log(data)
    data.studentNumber = studentNumber;
    console.log(data)
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {
        alert(`Applicant ${response.data.lastName}, ${response.data.firstName} was succesfully saved as student!`);
        axios
          .request({
            method: 'put',
            url: process.env.REACT_APP_URL+'/applicants/'+data.applicantId,
            data: {isStudent: true, studentId: response.data.studentId}
          })
          .then(response => {
            alert(`Successfully updated an applicant.`)
            this.getApplicants()
          })
          .catch(error => {
            console.log(error)
            if (error.response) {
              alert(`${error.response.data.error.message}`);
            } else if (error.request) {
              alert(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              alert('Error. Please contact your administrator for assistance.');
            }
            this.getApplicants()
          });
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.getApplicants()
      });
  }

  handleSaveAsOldStudent = (data, studentId) => {
    axios
      .request({
        method: 'put',
        url: process.env.REACT_APP_URL+'/applicants/'+data.applicantId,
        data: {isStudent: true, studentId: studentId}
      })
      .then(response => {
        alert(`Successfully updated an applicant.`)
        this.getApplicants()
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.getApplicants()
      });
  }

  handleAddStudentToSY = (schoolYearId, studentId, applicantId, gradeLevel) => {
    const url = process.env.REACT_APP_URL+'/students/addSchoolYear';
    axios
      .request({
        method: 'put',
        url: url,
        data: {schoolYearId, studentId, gradeLevel}
      })
      .then(response => {
        alert(`Student successfully added to the school year`);
        axios
          .request({
            method: 'put',
            url: process.env.REACT_APP_URL+'/applicants/'+applicantId,
            data: {isCurrentStudent: true}
          })
          .then(response => {
            alert(`Finished application.`)
            this.getApplicants()
          })
          .catch(error => {
            console.log(error)
            if (error.response) {
              alert(`${error.response.data.error.message}`);
            } else if (error.request) {
              alert(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              alert('Error. Please contact your administrator for assistance.');
            }
            this.getApplicants()
          });
      })
      .catch(error => {
        console.log('pasok sa error')
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.getApplicants()
      });
  }

  handleStudentPayment = (data, applicantId, isPaymentUponEnrollment) => {
    const url = process.env.REACT_APP_URL+'/payments';
    let d;
    if (isPaymentUponEnrollment) {
      d = {isPaymentDone: true, isPaid: true};
    } else {
      d = {isReservationDone: true, isPartiallyPaid: true};
    }
    axios
      .request({
        method: 'post',
        url: url,
        data
      })
      .then(response => {
        alert(`Payment for student successfully saved!`);
        if(this.state.paymentFile !== null) {
          this.handleUploadPaymentFile();
        }
        axios
          .request({
            method: 'put',
            url: process.env.REACT_APP_URL+'/applicants/'+applicantId,
            data: d
          })
          .then(response => {
            this.getApplicants()
            alert(`Notify the registrar to include the student to the school year.`)
          })
          .catch(error => {
            console.log(error)
            if (error.response) {
              alert(`${error.response.data.error.message}`);
            } else if (error.request) {
              alert(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              alert('Error. Please contact your administrator for assistance.');
            }
            this.getApplicants()
          });
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
        this.getApplicants()
      });
  }

  handleUploadFileChange = (paymentFile) => {
    this.setState({paymentFile});
  }

  handleUploadPaymentFile = () => {
    const url = process.env.REACT_APP_URL+'/assets/upload?module=payments';
    let fileData = new FormData();
    fileData.append('filePath', this.state.paymentFile);
    axios
      .request({
        method: 'post',
        url: url,
        data: fileData
      })
      .then(response => {
        alert(`OR Image was successfully saved.`);
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert('Error. Please contact your administrator for assistance.');
        }
      });
  }

  handleModalImportOpen = (open) => {
    this.setState({modalImportOpen: open})
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Applicants'});
    this.getSchoolYears();
    // this.getApplicants();
  }

  render() {
    return (
      <ApplicantsPV
        auth={this.props.auth}
        userType={this.props.userType}
        activePage={this.state.activePage}
        itemPerPage={this.state.itemPerPage}
        column={this.state.column}
        direction={this.state.direction}
        data={this.state.data}
        searchKey={this.state.searchKey}
        fields={this.state.fields}
        loaded={this.state.loaded}
        schoolYears={this.state.schoolYears}
        students={this.state.students}
        paymentFile={this.state.paymentFile}
        enrollmentFilename={this.state.enrollmentFile}
        gradeFilename={this.state.gradeFilename}
        modalImportOpen={this.state.modalImportOpen}
        gradeLevel={this.state.gradeLevel}
        schoolYearId={this.state.schoolYearId}
        handleChangeSchoolYear={this.handleChangeSchoolYear}
        handleModalImportOpen={this.handleModalImportOpen}
        isSearched={this.isSearched}
        onSearchChange={this.onSearchChange}
        handleSort={this.handleSort}
        handlePaginationChange={this.handlePaginationChange}
        handleFileChange={this.handleFileChange}
        handleDataSave={this.handleDataSave}
        handleRowClick={this.handleRowClick}
        handleSubmit={this.handleSubmit}
        handleUpdate={this.handleUpdate}
        handleDelete={this.handleDelete}
        getApplicants={this.getApplicants}
        handleSaveAsStudent={this.handleSaveAsStudent}
        handleSaveAsOldStudent={this.handleSaveAsOldStudent}
        handleAddStudentToSY={this.handleAddStudentToSY}
        handleStudentPayment={this.handleStudentPayment}
        handleUploadFileChange={this.handleUploadFileChange}
        handleUploadGradeFileChange={this.handleUploadGradeFileChange}
        handleUploadEnrollmentFileChange={this.handleUploadEnrollmentFileChange}
        getOldStudent={this.getOldStudent}
        handleChange={this.handleChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicantsPC);
